<template>
  <div>
      <!-- <b-card :title="$t('incident_form_handling_sub_title')">-->
        <b-row>
          <b-col md="12">
            <h4 class="mt-2 mb-2">{{_.get(requestForm, 'form.type_form_str', '')}}</h4>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="9">
            <b-form-group
              :label="$t('incident_form_protocol')"
              label-for="protocol">
              <b-form-input
                id="protocol"
                :value="_.get(requestForm, 'form.protocol_number')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3" class="print:hidden content-center">
            <ProtocolQueryHistoryPopup :protocol_number="_.get(requestForm, 'form.protocol_number')" type="incident" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('incident_form_date')"
              label-for="incident_form_date">
              <b-form-input
                id="incident_form_date"
                :value="_.get(requestForm, 'form.incident_date_fmt')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('incident_form_responsible_email')"
              label-for="incident_form_responsible_email">
              <b-form-input
                id="incident_form_responsible_email"
                :value="_.get(requestForm, 'form.responsible_email')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <!-- -->
        <FormIncidentGeneralDetail
          v-if="_.get(requestForm, 'form.type_form') === 'GE'"
          :entity="_.get(requestForm, 'form')">
        </FormIncidentGeneralDetail>
        <FormIncidentCoupAttemptDetail
          v-if="_.get(requestForm, 'form.type_form') === 'CA'"
          :entity="_.get(requestForm, 'form')">
        </FormIncidentCoupAttemptDetail>
        <!-- -->

        <b-row class="m-0">
          <b-col
            lg="12">
            <h5 class="mt-2 mb-0">{{$t('incident_form_handling')}}</h5>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>
         <b-row class="m-0">
          <b-col
            lg="4">
              <b-form-group
              :label="$t('incident_form_status')"
              label-for="status">
              <b-form-input
                id="status"
                :value="_.get(requestForm, 'status_str')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col lg="8" class="print:hidden content-center">
              <HandlingHistoryPopup :id="id" :serviceDelegate="services.incidentFormHandlingService" />
          </b-col>
        </b-row>
  </div>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import MediaList from '@/components/media/MediaList.vue'
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue'

//Services
import IncidentFormHandlingService from '@/services/api/incident/RequestFormIncidentHandlingService'
import ProtocolQueryHistoryPopup from '@/components/popup/ProtocolQueryHistoryPopup'
import HandlingHistoryPopup from '@/components/popup/HandlingHistoryPopup'
import FormIncidentGeneralDetail from './FormIncidentGeneralDetail.vue'
import FormIncidentCoupAttemptDetail from './FormIncidentCoupAttemptDetail.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BTable,
    MediaList,
    ProtocolQueryHistoryPopup,
    HandlingHistoryPopup,
    FormIncidentGeneralDetail,
    FormIncidentCoupAttemptDetail,
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    requestForm: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    id: null,
    requestForm : null,
    status: '',
    services: {
      incidentFormHandlingService: null,
    },
  }),
  methods: {
    getData(id) {
      this.$vs.loading()
      this.services.incidentFormHandlingService.read(id).then(
        data => {
          this.requestForm = data;
          this.status = _.get(data, 'request_form_incident_handling.status')
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    normalizeArrayToCheckbox(objs){
      if(objs){
        const normalizedArray = objs.map(function(obj) {
          return obj.id //Id data checked in checkbox
        })
        return normalizedArray
      }else{
        return []
      }
    }
  },
  watch: {

  },
  computed: {


  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }
    //Services

  },
  beforeMount() {
    const promisses = []

    //Services
    this.services.incidentFormHandlingService = IncidentFormHandlingService.build(this.$vs)


    //Services

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  }
}
</script>
